import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';


@Component({
  selector: 'app-notificationweb',
  templateUrl: './notificationweb.component.html',
  styleUrls: ['./notificationweb.component.scss']
})
export class NotificationwebComponent implements OnInit {
  dataList: any;
  currentUser: any;
  currentDate = new Date();

  constructor(public dialog: MatDialog, public tokenStorageService: TokenStorageService, private router: Router, private authService: AuthService,
    private toastr: ToastrService
  ) {


  }

  ngOnInit() {
    this.currentDate;

    this.currentUser = this.tokenStorageService.getUser();
    if (this.currentUser) {
      this.GetCurrentWebNotificationList();
    }
  }

  /**getActiveUserList */
  GetCurrentWebNotificationList() {

    this.authService.GetCurrentWebNotificationList(Number(this.currentUser.serviceid), 2).subscribe(response => {
      ;
      if (response) {       
          
          this.dataList = response;
        
      } else {
        this.toastr.error(response, "Error");
      }
    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, "Error");
      } else {
        this.toastr.error(err.error, "Error");
      }
    });
  }


}
